import { NotificationActionType, } from '../store/schema/NotificationViewState';
import removeNotification from '../actions/removeNotification';
var notificationHandlers = {};
export function ensureNotificationHandlerRegistered(actionType, handler) {
    var actionTypeString = NotificationActionType[actionType];
    if (!notificationHandlers[actionTypeString]) {
        notificationHandlers[actionTypeString] = handler;
    }
}
export function handleNotification(notification) {
    var handler = notificationHandlers[NotificationActionType[notification.actionType]];
    if (handler) {
        handler(notification);
    }
    removeNotification(notification);
}
//# sourceMappingURL=notificationHandler.js.map